// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"2":"436dde0a","234":"55fa9105","353":"cdfe68cf"}[chunkId] + ".js";
};